import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthHeader } from '../../components/AuthHeader';
import googleLogo from '../../../../assets/login/google.jpg';
import authApi from '../../../../api/authApi';

const LenderLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('user1@gmail.com');
  const [password, setPassword] = useState('123456');
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      await authApi.login(email, password);
      navigate('/home');
    } catch (e: any) {
      setErr(e?.message ?? 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    alert("Google sign-in is not configured for the lender portal yet.");
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <AuthHeader />
      <div className="flex flex-col items-center flex-1 bg-gray-50 p-5">
        <div className="w-full max-w-[573px] bg-white rounded-xl shadow-sm p-8 flex flex-col gap-6">
          <h1 className="w-full font-semibold text-2xl leading-[38px] text-center text-gray-800">
            Welcome back!
          </h1>

          <form onSubmit={onSubmit} className="flex flex-col gap-14">
            <div className="flex flex-col gap-4">
              {/* Email */}
              <div className="w-full">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full h-12 px-4 border rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter your email"
                  required
                />
              </div>

              {/* Password */}
              <div className="flex flex-col gap-1">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  Password
                </label>
                <div className="relative">
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full h-12 px-4 pr-12 border rounded-md bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter your password"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    {!showPassword ? (
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              <div className="w-full">
                <span
                  className="text-[16px] font-semibold text-gray-800 cursor-pointer underline"
                  onClick={() => navigate("/forgot-password")}
                >
                  Forgot Password?
                </span>
              </div>

              {err && <p className="text-sm text-red-600 mt-2">{err}</p>}
            </div>

            <div className="flex flex-col gap-6">
              <button
                type="submit"
                disabled={loading || !email}
                className={`button-1 w-full ${email && !loading ? "bg-gray-800 hover:bg-gray-700" : "!bg-gray-400 !cursor-not-allowed"}`}
              >
                {loading ? 'Logging in...' : 'Login'}
              </button>

              <div className="w-full flex items-center">
                <div className="flex-1 h-px bg-gray-300"></div>
                <span className="mx-4 text-[16px] text-gray-800 font-medium">or</span>
                <div className="flex-1 h-px bg-gray-300"></div>
              </div>

              <div className="w-full flex flex-col gap-6">
                <button
                  type="button"
                  onClick={handleGoogleLogin}
                  className="button-1 !bg-white !text-gray-800 w-full border border-gray-800 flex items-center justify-center gap-2"
                >
                  <img src={googleLogo} alt="Google" className="w-6 h-6" />
                  Continue with Google
                </button>

                <div className="w-full text-center">
                  <span className="text-[16px] text-[#6B7280]">Haven't got an account? </span>
                  <span
                    className="underline text-[16px] text-gray-800 font-medium cursor-pointer"
                    onClick={() => navigate("/signup")}
                  >
                    Sign up
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LenderLoginPage;
